
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M37 21c0-3.169-.825-6.143-2.263-8.729C38.407 10.79 41 7.201 41 3H19C9.059 3 1 11.059 1 21v13l2 14v14h19V50h14v-6h-4a3 3 0 110-6h4v-4h6l-5-13zm-3 11v4h-2c-2.757 0-5 2.243-5 5s2.243 5 5 5h2v2H20v12H5V47.858L3.02 33.999A8 8 0 0011 26a4 4 0 010-8v-5h20c.594 0 1.172-.062 1.737-.161A15.881 15.881 0 0135 21v.372L39.088 32H34zm23.081-7.993a2.35 2.35 0 00-4.238 2.017L57 36v8a3 3 0 10-6 0v8l4 4v6h8V35l-5.919-10.993z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M25.317 19.895L29.528 22l-4.211 2.105.894 1.79L34 22l-7.789-3.895zM38 40h2v2h-2zM42 40h2v2h-2zM42 44h2v2h-2zM42 36h2v2h-2zM46 36h2v2h-2zM46 32h2v2h-2zM46 40h2v2h-2zM46 44h2v2h-2zM46 48h2v2h-2z"}})])
          )
        }
      }
    